import webContextProvider from "../../providers/webContextProvider";

const MY_ASOS_DOMAIN = "https://my.asos.com";
const MY_ASOS_SERVICES_DOMAIN = "https://my.asosservices.com";

const getMyAccountUrl = path => {
  const isProduction = window.location.host === "www.asos.com";
  const domain = isProduction ? MY_ASOS_DOMAIN : MY_ASOS_SERVICES_DOMAIN;
  const { browseCountry, storeId } = webContextProvider();
  const url = new URL(`${domain}${path}`);
  url.searchParams.set("country", browseCountry);
  url.searchParams.set("store", storeId);

  return url.toString();
};

export default getMyAccountUrl;
